import {
  Box,
  Flex,
  Menu,
  MenuButton,
  MenuItem,
  MenuList,
  Text,
} from "@chakra-ui/react";

import FilterSVG from "@/assets/svg/filter.svg";
import { useBreakPoints } from "@/hooks/useBreakPoints";
import { useSortedMenu } from "@/hooks/useSortedMenu";
import { h_700_16_100_32 } from "@/styles/fontStyles";

import SortBySVG from "../../assets/svg/sort_by.svg";
// import { useActions } from '@/hooks/useActions';

function FilterAndSortBy({ handleClick }) {
  // const { setDeniedRequest } = useActions();
  return (
    <Flex alignItems="center" justifyContent={"space-between"}>
      <Flex
        alignItems="center"
        onClick={() => {
          handleClick();
          // setDeniedRequest(true);
        }}
        cursor={"pointer"}
      >
        <Text
          color={"mainBlue"}
          mr={"5px"}
          display={{ base: "flex", lg: "none" }}
        >
          Filter
        </Text>
        <Box display={{ base: "block", lg: "none" }}>
          <FilterSVG />
        </Box>
      </Flex>
      <SortedMenu />
    </Flex>
  );
}

export default FilterAndSortBy;

function SortedMenu() {
  const { isMobile } = useBreakPoints();
  const { listParams, handleChoiceSorted, handleClearSorted } = useSortedMenu();
  return (
    <Flex position={"relative"}>
      <Menu>
        <MenuButton>
          <Flex alignItems={"center"}>
            {isMobile && <Text>Sort By:</Text>}
            <SortBySVG />
          </Flex>
        </MenuButton>
        <MenuList
          position={"absolute"}
          minW={"fit-content"}
          right={{ base: "-88px", md: "-30px" }}
          p={"12px"}
          {...h_700_16_100_32}
        >
          {listParams &&
            listParams.map((item, index) => (
              <MenuItem
                p={"0px"}
                py={"8px"}
                key={`${item?.title}-${index}`}
                bg={"transparent"}
                onClick={() => handleChoiceSorted({ item })}
                _hover={{ bg: "transparent" }}
              >
                <Flex
                  gap={"12px"}
                  borderBottom={"2px solid"}
                  borderColor={"transparent"}
                  transition={"all 0.3s ease"}
                  _hover={{ borderColor: "red" }}
                >
                  <Text>{item?.title}</Text>
                  <Flex>
                    {item?.text && (
                      <Text whiteSpace={"nowrap"}>{item?.text}</Text>
                    )}
                    {item?.icon && item?.icon}
                  </Flex>
                </Flex>
              </MenuItem>
            ))}
          <MenuItem
            p={"0px"}
            py={"8px"}
            bg={"transparent"}
            onClick={() => handleClearSorted()}
            _hover={{ bg: "transparent" }}
          >
            <Text
              borderBottom={"2px solid"}
              borderColor={"transparent"}
              transition={"all 0.3s ease"}
              _hover={{ borderColor: "red" }}
            >
              Clear
            </Text>
          </MenuItem>
        </MenuList>
      </Menu>
    </Flex>
  );
}
